import * as Yup from 'yup';

export default Yup.object({
  locale: Yup.string().oneOf(['lt-LT', 'en-EU']).required(),
  Title: Yup.string().nullable(),
  Description: Yup.string().nullable(),
  Coordinates: Yup.object().typeError('Privaloma pasirinkti objekto lokaciją'),
  Region: Yup.string().nullable(),
  District: Yup.string().nullable(),
  GoldCoinAmount: Yup.number()
    .transform((value) => (value === '' || value === null || value === undefined ? undefined : value))
    .required('Privaloma įvesti auksinukų skaičių')
    .typeError('Įveskite teisingą skaičių')
    .integer('Įveskite sveikąjį skaičių')
    .min(0, 'Skaičius negali būti neigiamas'),
}).test('title-required-for-locale', function(value) {
  const { locale, Title } = value;
  if (locale === 'lt-LT' && !Title) {
    return this.createError({
      path: 'Title',
      message: 'Privaloma įvesti pavadinimą (LT)',
    });
  }
  return true;
});
